{
  "actions": "Acciones",
  "actionsAvailable": "Acciones disponibles.",
  "clearSelection": "Borrar selección",
  "selected": "{count, plural, =0 {Nada seleccionado} one {# seleccionado} other {# seleccionados}}",
  "selectedAll": "Todo seleccionado"
}
